import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { Router } from '@angular/router';
import { LocalStorageService } from '@/app/core/storage/local-storage.service';
import { SigninUserResponse, SigninUserResponseResponseResult } from '@/app/proxy/proxies';
import { BehaviorSubject } from 'rxjs';
import { LockScreenService } from '@/app/core/services/lock-screen.service';

@Injectable()
export class AuthService {
    private userSessionSubject = new BehaviorSubject<SigninUserResponse | null>(null);
    userSession$ = this.userSessionSubject.asObservable();

    constructor(
        private _localStorageService: LocalStorageService,
        private _router: Router,
        private _lockScreenService: LockScreenService
    ) {}

    isAuthenticated(): boolean {
        const token = this._localStorageService.getItem('token');
        const tokenExpiration = this._localStorageService.getItem('tokenExpiration');
        if (!token || !tokenExpiration) return false;

        const expirationDate = DateTime.fromISO(tokenExpiration as string);
        return !!token && expirationDate > DateTime.now();
    }

    getTokenExpirationDateTime(): DateTime {
        const tokenExpiration = this._localStorageService.getItem('tokenExpiration');
        return DateTime.fromISO(tokenExpiration as string);
    }

    handleSigninResponse(response: SigninUserResponseResponseResult): void {
        if (!response.result) {
            throw new Error('Invalid signin response');
        }

        this._localStorageService.setItem('userId', response.result.id);
        this._localStorageService.setItem('token', response.result.token);
        this._localStorageService.setItem('tokenExpiration', response.result.validUntil?.toString() ?? '');

        this.userSessionSubject.next(response.result);
    }

    logout(): void {
        this._localStorageService.clear();
        this._lockScreenService.unLock(); // Logout olduğunda lock screen'i de temizle
        this._router.navigate(['/auth/login']);
    }

    getCurrentSession(): SigninUserResponse | null {
        if (!this.isAuthenticated()) {
            return null;
        }

        const userId = this._localStorageService.getItem('userId');
        if (!userId) {
            return null;
        }

        const currentSession = this.userSessionSubject.getValue();
        if (!currentSession) {
            return new SigninUserResponse({
                id: userId as string,
                token: this._localStorageService.getItem('token') as string,
                validUntil: this._localStorageService.getItem('tokenExpiration')
                    ? DateTime.fromISO(this._localStorageService.getItem('tokenExpiration') as string)
                    : undefined,
            });
        }

        return currentSession;
    }
}
